import type { ReactNode } from 'react';

export const symbol_camera_indoor: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-120q-24.75 0-42.37-17.63Q160-155.25 160-180v-390q0-14.25 6.38-27 6.37-12.75 17.62-21l260-195q15.68-12 35.84-12Q500-825 516-813l260 195q11.25 8.25 17.63 21 6.37 12.75 6.37 27v390q0 24.75-17.62 42.37Q764.75-120 740-120H220Zm0-60h520v-394L480-763 220-574v394Zm260-292ZM350-274h178q14.45 0 24.22-9.77Q562-293.55 562-308v-54l60 31q8 4 15-.43 7-4.44 7-12.57v-103q0-8.13-7-12.57-7-4.43-15-.43l-60 31v-54q0-14.45-9.78-24.23Q542.45-517 528-517H350q-14.02 0-23.51 9.77Q317-497.45 317-483v175q0 14.45 9.49 24.23Q335.98-274 350-274Z"
		/>
	</svg>
);
